import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { RegistrationI } from 'src/app/core/interfaces/registration.interface';
import { CertificateService } from 'src/app/core/services/certificate/certificate.service';
import { MenuPopoverComponent } from './menu-popover/menu-popover.component';

@Component({
  selector: 'app-registration-card',
  templateUrl: './registration-card.component.html',
  styleUrls: ['./registration-card.component.scss'],
})
export class RegistrationCardComponent implements OnInit {
  @Input() cardConfig: RegistrationI;
  constructor(
    private popoverCtrl: PopoverController,
    private router: Router,
    private certificateS: CertificateService
  ) {}

  ngOnInit() {}

  async presentMenuPopover(e: Event, paid: boolean) {
    const popover = await this.popoverCtrl.create({
      component: MenuPopoverComponent,
      cssClass: 'alt-popover arrow-primary',
      reference: 'trigger',
      alignment: 'center',
      side: 'right',
      mode: 'ios',
      event: e,
      componentProps: {
        paid,
      },
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      //this.router.navigate(['/registrations/certificate/BREG86248307662']);
    }
  }
}
